const featureItems = [
  {
    id: 1,
    icon: 'ri-book-read-line',
    title: '下拉式阅读',
    desc: '独创无缝下拉引擎，告别翻页等待。整话内容一气呵成，追更流畅如丝般顺滑。',
  },
  {
    id: 2,
    icon: 'ri-refresh-line',
    title: '实时同步更新',
    desc: '每日 300+ 话同步上架，热门连载更新后 1 小时内即可阅读，追更快人一步。',
  },
  {
    id: 3,
    icon: 'ri-palette-line',
    title: '高清画质呈现',
    desc: '全站漫画高清扫描，原画级画质无损呈现。支持缩放查看细节，每一笔都清晰可见。',
  },
  {
    id: 4,
    icon: 'ri-global-line',
    title: '三端无缝同步',
    desc: '网页、APP、平板全平台覆盖。书签和阅读进度云端同步，随时随地继续阅读。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">为什么选择飞飞漫画</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            用心打磨每一个阅读细节，只为给你最好的免费漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-7 hover:border-primary-200 hover:bg-primary-50/20 transition-all group cursor-default"
            >
              <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mb-4 group-hover:bg-secondary-200 transition-colors">
                <i className={`${item.icon} text-secondary-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}